import { render, staticRenderFns } from "./lezhi_project1.vue?vue&type=template&id=413b7c86&scoped=true&"
import script from "./lezhi_project1.vue?vue&type=script&lang=js&"
export * from "./lezhi_project1.vue?vue&type=script&lang=js&"
import style0 from "./lezhi_project1.vue?vue&type=style&index=0&id=413b7c86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b7c86",
  null
  
)

export default component.exports